module.exports = __webpack_public_path__ + "static/foodmark-45838d1da1c539703e06ac4d7d5eedaa.png";